<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Department Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="department"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td style="width: 50px">
                      <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.department)"></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ row.item.department }}</td>
                    <td class="text-xs-left">{{ row.item.departmentDesc }}</td>
                  </tr>
                </template>
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'department')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'department')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    dept: String
  },
  data() {
    return {
      headers: [
        { text: '', value: 'department' },
        { text: 'Deparment', value: 'department' },
        { text: 'Description', value: 'departmentDesc' }
      ],
      selected: [],
      reportDepartment: [],
      menu: {},
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimDoc
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            // return as a menu list
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.doFetchDepartment()
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doFetchDepartment() {
      if (this.dept !== '') {
        this.reportDepartment = this.dept.split(',')
      }
      const apiURI = this.menu.getDepartmentList
      if (apiURI) {
        if (this.reportDepartment !== this.checkedItems) {
          // CBO: to reset the 'this.checkedItems' if called from different mode
          this.doReset()
          this.checkedItems = this.reportDepartment
        }
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            this.selectedItems = []
            const { data } = result.data
            if (data) {
              data.map((depmtList) => {
                const convertList = {
                  department: depmtList.dept,
                  departmentDesc: depmtList.deptDesc
                }
                if (this.checkedItems.includes(depmtList.dept)) {
                  const departmentList = {
                    department: depmtList.dept,
                    departmentDesc: depmtList.deptDesc
                  }
                  this.selectedItems.push(departmentList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
